import { render, staticRenderFns } from "./ElementosAduanaVenta.vue?vue&type=template&id=6d06a5e5&scoped=true&"
import script from "./ElementosAduanaVenta.vue?vue&type=script&lang=js&"
export * from "./ElementosAduanaVenta.vue?vue&type=script&lang=js&"
import style0 from "./ElementosAduanaVenta.vue?vue&type=style&index=0&id=6d06a5e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d06a5e5",
  null
  
)

export default component.exports